import { getAuth } from "../common/Helpers";
import { PARAM_NAME_TOKEN } from "../configurations/strings.config";

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const authGetClient = () => {
  const userToken = JSON.parse(getAuth(PARAM_NAME_TOKEN));
  if (userToken) {
    if (userToken.clientId !== "00000000-0000-0000-0000-000000000000" && userToken.clientId !== null && userToken.clientId !== undefined && userToken.clientId !== "") {
      return userToken.clientId;
    }
    else {
      let token = parseJwt(userToken.token)
      return JSON.parse(token.Permissions).ClientId;
    }
  }
};

export const authGetUserName = () => {
  const user = JSON.parse(getAuth(PARAM_NAME_TOKEN));
  if (user) {
    let token = parseJwt(user.token)
    return token.username;
  }
};

export const authGetPictureProfile = () => {
  const user = JSON.parse(getAuth(PARAM_NAME_TOKEN));
  if (user) {
    return user.profileUrl;
  }
};